module.exports = System.import('@enersis/gp-components/events');